<template>
  <div class='wrapper'>
    <navigator class='header' title="注册/绑定" :routePath='"/"'></navigator>

    <div class='body'>
      <van-field class="magh"
        readonly
        clickable
        name="picker"
        :value="value"
        placeholder="点击选择所属园区"
        @click="showPicker = true"
      />
      <van-popup v-model="showPicker" position="bottom">
        <van-picker
          show-toolbar
          :columns="columns"
          @confirm="onConfirm"
          @cancel="showPicker = false"
        />
      </van-popup>
      <mt-field class='phone' placeholder="请输入手机号" type="tel" v-model="userMobile"></mt-field>

      <mt-field class='smsCode' v-model="smsCode" type="tel"  placeholder="请输入验证码">
        <van-button class='send' @click.native='sendAccessCode' type='small'>{{access_msg}}</van-button>
      </mt-field>

      <div class='foot_bottom'>
        <van-button text='下一步' @click.native='next' block />
      </div>

    </div>

  </div>
</template>

<script>
import { Toast } from 'vant';
import { mapGetters, mapMutations } from 'vuex';

export default {
  data() {
    return {
      userMobile: '',
      smsCode: '',
      ukey: '',

      timer: 60,  // 默认倒数60秒
      stop: true,  // 默认是停止的
      Interval: null, // setInterval的对象

      duration: 1500,
      parkId:'',
      value: '',
      columns: [
        { text: '福田天安', value: 1000 },
        { text: '重庆天安', value: 1001 },
        { text: '佛山天安', value: 1002 },
        { text: '龙岗天安', value: 1003 },
        { text: '东莞天安', value: 1004 },
        { text: '广州番禺天安', value: 1005 },
        { text: '深业U中心', value: 1006 },
        { text: '俊安苑', value: 1007 },
        { text: '常州天安', value: 1008 },
        { text: '天津天安', value: 1010 },
        { text: '江阴天安', value: 1011 },
        { text: '青岛天安', value: 1012 },
        { text: '高尔夫花园', value: 1015 },
        { text: '武汉天安', value: 1016 },
        { text: '中山天安', value: 1017 },
        { text: '西安天安', value: 1018 },
        { text: '上海天安', value: 1019 },
        { text: '广东南海', value: 1020 },
      ],
      showPicker: false,
    };
  },
  methods: {
    ...mapMutations(['change_token', 'change_firstLogin', 'change_authorizedCode', 'change_user']),
    runTimer() {
      if (this.timer <= 0) {
        this.timer = 60;
        this.stop = true;
        clearInterval(this.Interval);
      } else {
        this.timer -= 1;
      }
    },
    onConfirm(value) {
      this.value = value.text;
      this.showPicker = false;
      this.parkId = value.value;
      console.log(value)
    },
    startTimer() {
      // 如果是false就开始倒计时，如果是true就停止倒计时
      if (!this.stop) {
        this.Interval = setInterval(this.runTimer, 1000);
      } else {
        clearInterval(this.Interval);
      }
    },
    sendAccessCode() {
      if (!this.stop) {
        return;
      }
      const phoneReg = /^1[3|4|5|6|7|8|9][0-9]\d{8}$/;

      if (!this.userMobile) {
        Toast.fail({ duration: this.duration, message:  '请输入手机号'});
        return;
      } else if (!phoneReg.test(this.userMobile)) {
        Toast.fail({ duration: this.duration, message:  '手机号格式错误'});
        return;
      }

      // 手机号正确的处理
      this.stop = false;
      this.startTimer();
      this.$http.post(`${this.URL_PREFIX}/app/added/user/send/sms`, {
        userMobile: this.userMobile,
        smsType: 6,
      }).then((response) => {
        const res = response.data;
        if (res.resCode === '10000') {
        } else if (res.resCode === '10203') {
          Toast.fail({ duration: this.duration, message:  res.resDesc});
        } else {
          this.stop = true;
          clearInterval(this.Interval);
          this.timer = 60;
          Toast.fail({ duration: this.duration, message:  res.resDesc});
        }
      });
    },

    next() {
      if (!this.smsCode) {
        Toast.fail({ duration: this.duration, message:  '请输入验证码'});
        return;
      }
      this.$http.post(`${this.URL_PREFIX}/app/quick/auth/user/register`, {
        type: 1,
        parkId:this.parkId,
        userMobile: this.userMobile,
        validateCode: this.smsCode,
        ukey: this.ukey,
      }).then((response) => {
        const res = response.data;
        if (res.resCode === '10000') {
          this.change_token(res.resData.token);
          this.getUserInfo(res.resData.token);
          // 此处必须使用这样粗暴的跳转方式
          // 因为iOS微信有坑，如果你用push或replace，实际上微信浏览器的地址没有发生改变，会导致首页扫码签名校验失败
          // 详情：https://segmentfault.com/q/1010000012588051
          window.location.href = this.URL_PREFIX_PAGE + this.curPath
        } else if (res.resCode === '17106') {
          this.$router.replace({ path: '/auth/login', query: { ukey: this.ukey, userMobile: this.userMobile, validateCode: this.smsCode }});
        } else {
          Toast.fail({ duration: this.duration, message:  res.resDesc});
        }
      });
    },
    getUserInfo(token) {
      this.$http.post(`${this.URL_PREFIX}/app/get/user/info/detail`, {}, {
        headers: { token: token },
      }).then((response) => {
        const res = response.data;
        if (res.resCode === '10000') {
          this.change_user(res.resData);
        }
      });
    },
  },
  computed: {
    ...mapGetters(['curPath']),
    access_msg() {
      return this.stop ? '发送验证码' : `${this.timer}秒后可重新发送`;
    },
  },
  created() {
    this.ukey = this.$route.query.ukey;
  },
};
</script>


<style lang="scss" scoped>
.wrapper{
  position: absolute;
  top: 0;
  bottom: 0;
  width: 100%;
  background: #fff;
  .body{
    .mint-field{
      padding: 0 .266667rem;
      // height: 1.173333rem;
      line-height: 88px;
      font-size: .4rem;
      color: rgb(67, 67, 67);
      // border-bottom: .013333rem solid rgb(245, 245, 245);
    }
    .phone{
      // margin-top: 2.666667rem;
    }
    .magh{
      margin-top: 2rem;
      color: red;
    }
    .smsCode{
      margin-bottom: 1.2rem;
      .send{
        padding: 0;
        border: none;
        outline: 0;
        background: #fff;
      }
    }

    .foot_bottom{
      padding: 0 .8rem;
      .van-button{
        border-radius: .666667rem;
        background: #d0011b;
        color: #fff;
        font-size: .48rem;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/auth/Regist.vue